export class epalGatewaySpareParts{
    gatewayMacAddress: string;
    gatewayType: string;
    simCardIccId: string;
    simCardIccId2: string;
    password: string;
    deviceGatewayTypeId: number;    
}